import ForgotPassword from 'packages/auth/ForgotPassword';
import LoginPage from 'packages/auth/login/Login';
import RegisterPage from 'packages/auth/register/Register';
import AppContextProvider from 'packages/context/AppContext';
import HomePage from 'packages/home/Home';
import {Route, Switch} from 'react-router-dom';
import Admin from '../admin/Admin';
import PrivateRoute from './PrivateRoute';

const RootRouter = () => {
  return (
    <>
      <Switch>
        <Route
          path="/"
          exact
          component={() => (
            <AppContextProvider>
              <LoginPage />
            </AppContextProvider>
          )}
        />
        <Route
          path="/register"
          component={() => (
            <AppContextProvider>
              <RegisterPage />
            </AppContextProvider>
          )}
        />
        <Route
          path="/password-reset"
          component={() => (
            <AppContextProvider>
              <ForgotPassword />
            </AppContextProvider>
          )}
        />
        <PrivateRoute path="/app" component={HomePage} />
        <PrivateRoute path="/admin" component={Admin} />
      </Switch>
    </>
  );
};

export default RootRouter;
